import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/syslog';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async stadiumUserList(params: any) {
    return api.stadiumUserList(params);
  }

  @Action
  async stadiumUserTrack(params: any) {
    return api.stadiumUserTrack(params);
  }

  @Action
  async count(params: any) {
    return api.count(params);
  }

  @Action
  async allOperationData(params: any) {
    return api.allOperationData(params);
  }

  @Action
  async allCountData(params: any) {
    return api.allCountData(params)
  }

  @Action
  async stadiumData(params: any) {
    return api.stadiumData(params)
  }

  @Action
  async enterapplyData(params: any) {
    return api.enterapplyData(params)
  }

  @Action
  async manager(params: any) {
    return api.manager(params)
  }
}
